import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import './i18n';
import './instrument';
import './index.css';
import App from './App.jsx';

// Disable browser's automatic scroll restoration to let our custom ScrollRestoration component handle it
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // Use cache within 30 seconds (works with NavigationHandler for precise control)
      gcTime: 5 * 60 * 1000, // Clear cache after 5 minutes
      refetchOnWindowFocus: false, // Don't auto-refetch when window regains focus
      retry: 1, // Retry once on failure
    },
  },
});

createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <StrictMode>
      <App />
    </StrictMode>
  </QueryClientProvider>,
)
